import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-mnd.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-mnd.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Validators } from "@angular/forms";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { debounceTime, take, takeUntil } from "rxjs";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { ViewApplicationLocationMndConstants } from "./view-application-location-mnd.constants";
import { MondiModuleService } from "../../../../../shared/services/modules/mondi-module.service";
import { WorkflowJobService } from "src/app/shared/services/workflow-job/workflow-job.service";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
let ViewApplicationLocationMndComponent = class ViewApplicationLocationMndComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    jobService;
    appController;
    changeDetectorRefs;
    mapService;
    modalService;
    mondiService;
    requestStatusService;
    viewApplicationService;
    saveBtnPlaceholder = ViewApplicationLocationMndConstants.SAVE_BUTTON_PLACEHOLDER;
    locationForm;
    descriptionLabel1 = ViewApplicationLocationMndConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationMndConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationMndConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationMndConstants.DESCRIPTION_LABEL_4;
    modalOptions = ViewApplicationLocationMndConstants.MODAL_OPTION;
    validationMessages = ViewApplicationLocationMndConstants.VALIDATION_MESSAGES;
    regionFormControlName = ViewApplicationLocationMndConstants.REGION_FORM_CONTROL_NAME;
    areaFormControlName = ViewApplicationLocationMndConstants.AREA_FORM_CONTROL_NAME;
    wpuFormControlName = ViewApplicationLocationMndConstants.WPU_FORM_CONTROL_NAME;
    plantationFormControlName = ViewApplicationLocationMndConstants.PLANTATION_FORM_CONTROL_NAME;
    compartmentFormControlName = ViewApplicationLocationMndConstants.COMPARTMENT_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    regionLabel = ViewApplicationLocationMndConstants.REGION_LABEL;
    areaLabel = ViewApplicationLocationMndConstants.AREA_LABEL;
    wpuLabel = ViewApplicationLocationMndConstants.WPU_LABEL;
    plantationLabel = ViewApplicationLocationMndConstants.PLANTATION_LABEL;
    compartmentLabel = ViewApplicationLocationMndConstants.COMPARTMENT_LABEL;
    locationHeading = ViewApplicationLocationMndConstants.LOCATION_HEADING_LABEL;
    regions = [];
    areas = [];
    wpus = [];
    plantations = [];
    compartments = [];
    disableCompartment = true;
    mapComponent;
    application;
    isMapLoaded = false;
    selectedGraphic = null;
    clearLayerGraphicsSubjectSubscription;
    mndTableDataLoadedSubjectSubscription;
    getMapDataObservableSubscription;
    getMappedLayerDataObservableSubscription;
    selectedMndLayerSubject;
    getSetLocationObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, jobService, appController, changeDetectorRefs, mapService, modalService, mondiService, requestStatusService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.jobService = jobService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.modalService = modalService;
        this.mondiService = mondiService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToLocation();
        this.loadMapData();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionMndRegionEnabled = false;
        this.mapService.actionMndAreaEnabled = false;
        this.mapService.actionMndWPUEnabled = false;
        this.mapService.actionMndPlantationEnabled = false;
        this.mapService.actionMndCompartmentEnabled = false;
    }
    ngOnDestroy() {
        this.mapService.actionMndCompartmentEnabled = false;
    }
    handleRouteChange() {
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.getApplication();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("locationForm");
        this.locationForm = form;
        this.locationForm.disable();
    }
    syncMapGeometries() {
        const geometries = [];
        const geomPoint = this.locationForm.get("point").value;
        const geomPolygon = this.locationForm.get("polygon").value;
        const geomLine = this.locationForm.get("polyline").value;
        if (geomPoint !== null) {
            geometries.push(geomPoint);
        }
        if (geomPolygon !== null) {
            geometries.push(geomPolygon);
        }
        if (geomLine !== null) {
            geometries.push(geomLine);
        }
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Mondi module graphics", true);
        }
    }
    subscribeToLocation() {
        this.selectedMndLayerSubject = this.mapService.$selectedMndLayer.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfLocationIsAlreadyLoaded(property);
            }
        });
    }
    checkIfLocationIsAlreadyLoaded(property) {
        const title = "Replace Location";
        const contentMessage = "An application can only have 1 Location. Do you want to replace the current location?";
        const propertyControl = this.locationForm.get("polygon").value;
        if (propertyControl) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.locationForm.reset();
                    this.mapComponent.clearGraphics("Mondi module graphics");
                    this.setLocationData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setLocationData(property.attributes, property.geometry);
        }
    }
    setLocationData(locationObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        this.locationForm.get("region").setValue(this.locationDataAlternateColumnName(locationObject, "REGION_NAME", "region_name"), [Validators.required]);
        this.locationForm.get("area").setValue(this.locationDataAlternateColumnName(locationObject, "AREA_NAME", "area_name"), [Validators.required]);
        this.locationForm.get("wpu").setValue(this.locationDataAlternateColumnName(locationObject, "WPU_CODE", "wpu_code"), [Validators.required]);
        this.locationForm.get("plantation").setValue(this.locationDataAlternateColumnName(locationObject, "PLANTATION_CODE", "plantation_code"), [Validators.required]);
        this.locationForm.get("compartment").setValue(this.locationDataAlternateColumnName(locationObject, "SUB_COMPT_KEY", "sub_compt_key"), [Validators.required]);
        if (locationObject.layerName !== "area" && locationObject.layerName !== "region") {
            let selectedFeature;
            if (locationObject.layerName === "compartment") {
                selectedFeature = this.compartments.find(x => x.code === this.locationForm.get("compartment").value);
            }
            if (locationObject.layerName === "plantation") {
                selectedFeature = this.plantations.find(x => x.code === this.locationForm.get("plantation").value);
            }
            if (locationObject.layerName === "work plan unit") {
                selectedFeature = this.wpus.find(x => x.code === this.locationForm.get("wpu").value);
            }
            if (selectedFeature) {
                this.locationForm.get("selectedLayer").setValue(locationObject.layerName);
                this.locationForm.get("selectedFeatureName").setValue(selectedFeature.selectedFeatureName);
                this.locationForm.get("selectedFeatureKey").setValue(selectedFeature.selectedFeatureKey);
                this.mapLayerData(locationObject.layerName, selectedFeature.selectedFeatureKey);
                if (geometry.type === "point") {
                    this.locationForm.get("point").setValue(geometry);
                }
                else if (geometry.type === "polygon") {
                    this.locationForm.get("polygon").setValue(geometry);
                }
                else if (geometry.type === "polyline") {
                    this.locationForm.get("polyline").setValue(geometry);
                }
                this.syncMapGeometries();
            }
        }
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    locationDataAlternateColumnName(locationObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(locationObject)) {
            if (key === name1) {
                returnVal = locationObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = locationObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = locationObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    mapLayerData(layer, name) {
        const params = {
            layer,
            name
        };
        this.getMappedLayerDataObservableSubscription = this.mondiService.getMappedLayerDataObservable(+this.moduleID, params).subscribe(data => {
            if (data.region) {
                this.locationForm.get("region").setValue(data.region.regionName);
            }
            else {
                this.locationForm.get("region").setValue(null);
            }
            if (data.area) {
                this.locationForm.get("area").setValue(data.area.areaName);
            }
            else {
                this.locationForm.get("area").setValue(null);
            }
            if (data.wpu) {
                this.locationForm.get("wpu").setValue(data.wpu.wpuCode);
            }
            else {
                this.locationForm.get("wpu").setValue(null);
            }
            if (data.plantation) {
                this.locationForm.get("plantation").setValue(data.plantation.plantationCode);
                // this.locationForm.get("compartment").enable();
                if (data.compartment != null) {
                    this.locationForm.get("compartment").setValue(data.compartment.subComptKey);
                }
                this.getCompartmentDataByCode();
            }
            else {
                this.locationForm.get("plantation").setValue(null);
                this.locationForm.get("compartment").disable();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    getApplication() {
        const params = {
            $expand: `ApplicationLine,ApplicationPoint,ApplicationPolygon`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationMndConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            if (this.application.applicationPoint) {
                const pointGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.applicationPoint.shape, 102100);
                const point = JsonUtils.fromJSON(pointGeometryArc);
                this.locationForm.get("point").setValue(point);
            }
            if (this.application.applicationLine) {
                const lineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.applicationLine.shape, 102100);
                const line = JsonUtils.fromJSON(lineGeometryArc);
                this.locationForm.get("polyline").setValue(line);
            }
            if (this.application.applicationPolygon) {
                const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.applicationPolygon.shape, 102100);
                const polygon = JsonUtils.fromJSON(polygonGeometryArc);
                this.locationForm.get("polygon").setValue(polygon);
            }
            this.syncMapGeometries();
            this.mapLayerData(this.application.layerName, this.application.featureKey);
        }
    }
    onRegionChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Region", `REGION_NAME='${element.value}'`);
    }
    onAreaChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Area", `AREA_NAME='${element.value}'`);
    }
    onWPUChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("WorkPlanUnit", `WPU_CODE='${element.value}'`);
    }
    onPlantationChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Plantation", `PLANTATION_CODE='${element.value}'`);
    }
    onCompartmentChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Compartment", `SUB_COMPT_KEY='${element.value}'`);
    }
    loadMapData() {
        this.requestStatusService.showBusySpinner("LoadMapDataMnd");
        this.getMapDataObservableSubscription = this.mondiService.getMapDataObservable(+this.moduleID, {}).subscribe({
            next: data => {
                if (data.regions != null || data.regions.features.length > 0) {
                    data.regions.features.forEach(region => {
                        this.regions.push({ value: region.attributes.regionName, code: region.attributes.regionName });
                        this.regions.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                if (data.areas != null || data.areas.features.length > 0) {
                    data.areas.features.forEach(area => {
                        this.areas.push({ value: area.attributes.areaName, code: area.attributes.areaName });
                        this.areas.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                if (data.wpUs != null || data.wpUs.features.length > 0) {
                    data.wpUs.features.forEach(wpu => {
                        this.wpus.push({ value: wpu.attributes.wpuName, code: wpu.attributes.wpuCode });
                        this.wpus.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                if (data.plantations != null || data.plantations.features.length > 0) {
                    data.plantations.features.forEach(plantation => {
                        this.plantations.push({
                            value: plantation.attributes.plantationName,
                            code: plantation.attributes.plantationCode
                        });
                        this.plantations.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationMndConstants.STEP_TITLE, error, CRUDOperation.Get);
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    getCompartmentDataByCode() {
        this.requestStatusService.showBusySpinner("LoadMapDataMnd");
        const plantationCode = this.locationForm.get("plantation").value;
        const plantation = this.plantations.find(x => x.code === plantationCode);
        const params = {
            value: plantation.code,
            field: "PLANTATION_CODE"
        };
        this.getMapDataObservableSubscription = this.mondiService.getCompartmentsDataByCode(+this.moduleID, params).subscribe({
            next: data => {
                if (data != null || data.features.length > 0) {
                    data.features.forEach(compartment => {
                        this.compartments.push({ value: compartment.attributes.subCompt, code: compartment.attributes.subComptKey });
                        this.compartments.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationMndConstants.STEP_TITLE, error, CRUDOperation.Get);
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    onBtnSaveClicked($event) {
        if (this.locationForm.valid) {
            const point = this.locationForm.get("point").value;
            const polyline = this.locationForm.get("polyline").value;
            const polygon = this.locationForm.get("polygon").value;
            const polylineDto = this.locationForm.get("polylineDto").value;
            const polygonDto = this.locationForm.get("polygonDto").value;
            const pointDto = this.locationForm.get("pointDto").value;
            const params = {
                applicationPoint: null,
                applicationLine: null,
                applicationPolygon: null
            };
            if (polygon !== null) {
                if (polygonDto === null) {
                    const applicationPolygon = {
                        wkid: 102100,
                        shape: WktConverterUtils.ConvertArcGISJsonToWkt(polygon)
                    };
                    params.applicationPolygon = applicationPolygon;
                }
                else {
                    polygonDto.shape = WktConverterUtils.ConvertArcGISJsonToWkt(polygon);
                    params.applicationPolygon = polygonDto;
                }
            }
            if (polyline !== null) {
                if (polylineDto === null) {
                    const applicationPolyline = {
                        wkid: 102100,
                        shape: WktConverterUtils.ConvertArcGISJsonToWkt(polyline)
                    };
                    params.applicationLine = applicationPolyline;
                }
                else {
                    polylineDto.shape = WktConverterUtils.ConvertArcGISJsonToWkt(polyline);
                    params.applicationLine = polylineDto;
                }
            }
            if (point !== null) {
                if (pointDto === null) {
                    const applicationPoint = {
                        wkid: 102100,
                        shape: WktConverterUtils.ConvertArcGISJsonToWkt(point)
                    };
                    params.applicationPoint = applicationPoint;
                }
                else {
                    pointDto.shape = WktConverterUtils.ConvertArcGISJsonToWkt(point);
                    params.applicationPoint = pointDto;
                }
            }
            this.getSetLocationObservableSubscription =
                this.mondiService.getSetLocationObservable(this.application.id, params)
                    .subscribe({
                    next: appSaveresponse => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationMndConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: WorkflowJobService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: NgbModal },
        { type: MondiModuleService },
        { type: RequestStatusService },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationMndComponent = __decorate([
    Component({
        selector: "app-view-application-location-mnd",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationMndComponent);
export { ViewApplicationLocationMndComponent };
